export default __webpack_public_path__ + "static/media/torso-mid-front.88c16ec2.png";